module.exports = __webpack_public_path__ + "static/media/attribute_ranged_magic.3b369dd3.png";